import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X, Download } from "lucide-react";
import api from "@/lib/api";

const KEY = "fc_whatsnew_seen";

export const WhatsNewBanner = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get("/app/whats-new")
      .then((r) => {
        if (localStorage.getItem(KEY) !== r.data.version) setData(r.data);
      })
      .catch(() => {});
  }, []);

  if (!data) return null;

  const dismiss = () => {
    localStorage.setItem(KEY, data.version);
    setData(null);
  };

  const downloadPdf = () => {
    const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
    window.open(`${base}/api/manual/novedades`, "_blank");
  };

  return (
    <div
      className="relative overflow-hidden rounded-xl border border-emerald-200 bg-emerald-50 px-5 py-4 mb-6"
      data-testid="whatsnew-banner"
    >
      <button
        onClick={dismiss}
        className="absolute top-3 right-3 text-emerald-700/60 hover:text-emerald-900"
        title="No volver a mostrar"
        data-testid="whatsnew-dismiss"
      >
        <X className="h-4 w-4" />
      </button>
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 rounded-lg bg-emerald-600/10 grid place-items-center shrink-0">
          <Sparkles className="h-5 w-5 text-emerald-700" strokeWidth={1.7} />
        </div>
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-emerald-700">
            Novedades · v{data.version}
          </div>
          <div className="font-bold text-emerald-950">{data.headline}</div>
          <ul className="mt-2 space-y-1 text-sm text-emerald-900/85">
            {data.items.map((it, i) => (
              <li key={i} className="flex gap-2">
                <span className="text-emerald-600">•</span>
                <span>{it}</span>
              </li>
            ))}
          </ul>
          <div className="mt-3 flex flex-wrap gap-2">
            <button
              onClick={downloadPdf}
              className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-emerald-700 text-white text-xs font-bold hover:bg-emerald-800"
              data-testid="whatsnew-download"
            >
              <Download className="h-3.5 w-3.5" /> Listado de mejoras
            </button>
            <Link
              to="/stock-parado"
              onClick={dismiss}
              className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-white border border-emerald-300 text-emerald-800 text-xs font-bold hover:bg-emerald-100"
              data-testid="whatsnew-goto"
            >
              Ver stock que no vendes
            </Link>
            <button
              onClick={dismiss}
              className="px-3.5 py-2 text-xs font-bold uppercase tracking-wider text-emerald-700/70 hover:text-emerald-900"
              data-testid="whatsnew-hide"
            >
              Entendido
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
